import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { captureTrafficSource } from './lib/trafficSource';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

captureTrafficSource();

function removeLoadingSpinner() {
  const loadingSpinner = document.getElementById('loading-spinner');
  if (loadingSpinner) {
    loadingSpinner.remove();
  }
}

function StartupComplete() { React.useEffect(removeLoadingSpinner, []); return null; }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode><BrowserRouter><StartupComplete /><App /></BrowserRouter></React.StrictMode>
);

// Service Worker Registration
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/service-worker.js')
//       .then(registration => {
//         console.log('ServiceWorker registered with scope:', registration.scope);
//       })
//       .catch(error => {
//         console.log('ServiceWorker registration failed:', error);
//       });
//   });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
